import React from "react";
import { useNavigate } from "react-router-dom";
import { Moon, Sun, LogOut } from "lucide-react";

export default function AdminProfileMenu({
  onLogout,
  onAccount,
  darkMode,
  setDarkMode,
  showProfile,
  setShowProfile,
}) {
  const navigate = useNavigate(); // ✅ navigation hook

  return (
    <div className="relative select-none">
      {/* 🔹 Profile Button */}
      <button
        onClick={() => setShowProfile(!showProfile)}
        className="relative w-10 h-10 rounded-full overflow-hidden border-2 border-[#1da1f2] hover:border-[#00bfff] shadow-lg transition-all duration-300"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/2202/2202112.png"
          alt="Admin"
          className="w-full h-full object-cover"
        />
        <span className="absolute inset-0 rounded-full shadow-[0_0_10px_#1da1f2] opacity-60"></span>
      </button>

      {/* 🧩 Dropdown Menu */}
      {showProfile && (
        <div
          className={`absolute right-0 mt-3 w-64 rounded-2xl shadow-2xl border border-[#1e293b] z-50 overflow-hidden backdrop-blur-md ${
            darkMode ? "bg-[#0f172a]/95 text-white" : "bg-white/95 text-black"
          } animate-fade-up`}
        >
          {/* 👤 Header */}
          <div className="flex flex-col items-center py-4 border-b border-gray-700/30">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2202/2202112.png"
              alt="Admin Avatar"
              className="w-16 h-16 rounded-full border-2 border-[#1da1f2] shadow-[0_0_10px_#1da1f2]"
            />
            <div className="mt-2 flex items-center gap-2 font-bold text-lg">
              VIP ADMIN
              <span className="relative flex items-center justify-center w-5 h-5 rounded-full bg-gradient-to-br from-[#1da1f2] to-[#7b3fff] animate-pulse-glow -mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="white"
                  className="w-3.5 h-3.5"
                >
                  <path d="M12 2l2.4 7.2h7.6l-6 4.4 2.3 7.2L12 16l-6.3 4.8 2.3-7.2-6-4.4h7.6z" />
                </svg>
              </span>
            </div>
            <p className="text-xs opacity-70 mt-1">Administrator Panel</p>
          </div>

          {/* ⚙️ Account */}
          <button
            onClick={() => {
              setShowProfile(false);
              if (onAccount) onAccount();
            }}
            className={`w-full text-left px-5 py-3 hover:bg-[#1e293b]/40 flex items-center gap-3 transition-all ${
              darkMode ? "text-white" : "text-gray-800"
            }`}
          >
            👤 Account
          </button>

          {/* 🌙 Dark Mode */}
          <div className="flex justify-between items-center px-5 py-3 border-t border-gray-700/20">
            <span className="flex items-center gap-2 text-sm">
              {darkMode ? <Moon size={18} /> : <Sun size={18} />} Dark Mode
            </span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={darkMode}
                onChange={() => setDarkMode(!darkMode)}
              />
              <div className="w-11 h-6 bg-gray-400 peer-focus:ring-4 peer-focus:ring-[#1da1f2]/50 rounded-full peer-checked:bg-[#1da1f2] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
            </label>
          </div>

          {/* 🔴 Logout */}
          <div className="px-5 py-3 border-t border-gray-700/20">
            <button
              onClick={() => {
                setShowProfile(false);

                // 🧹 Clear all admin session data
                localStorage.removeItem("adminToken");
                localStorage.removeItem("admin");
                sessionStorage.clear();

                // ✅ React Router navigate (no 404, no reload)
                navigate("/admin/login", { replace: true });

                if (onLogout) onLogout();
              }}
              className="w-full text-left text-red-500 font-semibold hover:bg-red-500 hover:text-white px-3 py-2 rounded-lg transition-all flex items-center gap-2"
            >
              <LogOut size={18} /> Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}